import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Skeleton, Space, Typography, Divider } from 'antd';
import PostCard from '../../components/PostCard';
import { blogPosts } from '../../api/mockData';
import './index.css';

const { Content } = Layout;
const { Title } = Typography;

const HomePage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 模拟从API获取数据
    setTimeout(() => {
      setPosts(blogPosts);
      setLoading(false);
    }, 500);
  }, []);

  return (
    <Layout className="home-layout">
      <Content className="home-content">
        <div className="home-header">
          <Title level={2} className="home-title">欢迎来到我的博客</Title>
          <p className="home-subtitle">分享技术，记录生活</p>
        </div>
        
        <Divider />
        
        <div className="posts-container">
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            {loading ? (
              Array.from({ length: 4 }).map((_, index) => (
                <Row key={index} gutter={[16, 16]}>
                  <Col span={24}>
                    <Skeleton active avatar paragraph={{ rows: 2 }} />
                  </Col>
                </Row>
              ))
            ) : posts.length > 0 ? (
              posts.map(post => (
                <Row key={post.id} gutter={[16, 16]}>
                  <Col span={24}>
                    <PostCard post={post} />
                  </Col>
                </Row>
              ))
            ) : (
              <div className="no-posts">
                <p>暂无文章</p>
              </div>
            )}
          </Space>
        </div>
      </Content>
    </Layout>
  );
};

export default HomePage;